"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetState = exports.setStateValue = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
// other initial states...
};
var dynamicStateSlice = (0, toolkit_1.createSlice)({
    name: 'dynamic',
    initialState: initialState,
    reducers: {
        setStateValue: function (state, action) {
            var _a = action.payload, path = _a.path, value = _a.value;
            var pathParts = path.split('.');
            var current = state;
            // Create nested objects if they don't exist
            for (var i = 0; i < pathParts.length - 1; i++) {
                if (!current[pathParts[i]]) {
                    current[pathParts[i]] = {};
                }
                current = current[pathParts[i]];
            }
            // console.log("unmount", pathParts[pathParts.length - 1])
            // Set the value at the final pat
            current[pathParts[pathParts.length - 1]] = value;
        },
        resetState: function (state, action) {
            var _a, _b;
            var pages = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.pages;
            var page = (_b = action.payload) === null || _b === void 0 ? void 0 : _b.page;
            // Support for multiple pages to reset
            if (Array.isArray(pages) && pages.length > 0) {
                // Reset only specific pages in the array
                pages.forEach(function (pageKey) {
                    if (state[pageKey]) {
                        delete state[pageKey];
                    }
                });
            }
            // Backward compatibility for single page
            else if (page) {
                if (state[page]) {
                    delete state[page];
                }
            }
            // If no pages specified, reset everything
            else {
                Object.keys(state).forEach(function (key) {
                    delete state[key];
                });
            }
            // Initialize with empty state
            Object.assign(state, initialState);
        },
    },
});
// Export the action creator separately
exports.setStateValue = dynamicStateSlice.actions.setStateValue;
exports.resetState = dynamicStateSlice.actions.resetState;
// Export the reducer function directly
exports.default = dynamicStateSlice.reducer;
